---
title: "Reporting a Defect"
slug: reporting-a-defect
description: "Step-by-step guide for recording damage or a defect on a package with photo documentation."
keywords:
  - defect
  - damage
  - report
  - package
  - GRAI
  - photo
  - defect report
---

## Prerequisites

- Role: Scanner, Manager, or Company Admin
- The affected package must carry a readable GRAI identifier
- At least one photo or video of the damage must be available

## Steps

1. Navigate to **Support** in the menu and select **Defect Reporting**.
2. Enter the GRAI identifier of the damaged package or scan the QR code.
3. Select your current location from the **Location** dropdown.
4. Enter a precise description of the damage under **Defect Description**, for example "torn corner", "broken seal", or "water damage". At least 10 characters are required.
5. Under **Photos/Videos**, click **Click to upload images or videos** and select at least one file. Maximum 5 files (JPG, PNG, GIF, MP4, MOV, AVI, or WebM).
6. Click **Report Defect** to submit the report.
7. The hey circle support team receives a review task and will follow up with you.

## If something goes wrong

- **"Please provide a description"** — The description field is empty or contains fewer than 10 characters. Add a meaningful description of the damage.
- **"At least one photo or video is required"** — Upload at least one media file before submitting.
- **"Package not found"** — Verify the entered package ID.
- **"You are not authorized to report defects at this location"** — Contact your Company Admin to review the location assignment.
- **Network error** — The report was not submitted. Check your connection and try again.
- Contact us: support@heycircle.com or use the feedback button in the bottom-right corner of the screen.

## Related Articles

- [Receiving a Package](/app/help?article=scanning-a-package)
- [Sending a Package](/app/help?article=sending-a-package)
- [Reading the Analytics Dashboard](/app/help?article=viewing-analytics)
